import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a1242992ab6ae00146e53c3/fandomcasefiles/src/app/forgot-password/components/ForgotPasswordScreen.tsx");
